export default __webpack_public_path__ + "static/media/Upload.ae193215.png";